var map = {
	"./Cards/index.ts": 12951,
	"./Lefty/index.ts": 26278,
	"./NiftyFifty/index.ts": 25176,
	"./Panels/index.ts": 61093,
	"./SimpleBlog/index.ts": 86706,
	"./Townhall/index.ts": 74193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20846;